export default __webpack_public_path__ + "static/oculAr-2ce1ba2d6c41f8600c1ce6380bf6708f.svg";